module.exports = __webpack_public_path__ + "img/out_of_bounds_left.2833606a.jpg";